module.exports = __webpack_public_path__ + "img/intruduce-title.ddc2c6d7.png";